<!-- @prettier -->
<template>
  <PortalWidget :widget="widget">
    <div v-if="!isLoading">
      <ValidationObserver
        v-slot="{ handleSubmit, invalid, pristine }"
        ref="form"
      >
        <form
          class="form-horizontal"
          name="editProfile"
          novalidate
          @submit.prevent="handleSubmit(updateProfile)"
        >
          <fieldset>
            <div class="container-fluid">
              <!-- First Name -->
              <div class="form-group">
                <label class="col-sm-3 col-md-3 control-label">
                  {{ $t('PROFILE_FIRST_NAME') }}
                  <a
                    v-tooltip="$t('PROFILE_FIRST_NAME_TT')"
                    class="tooltip-icon"
                  >
                    <i class="fa m-l-3 fa-question-circle" />
                  </a>
                </label>

                <ValidationProvider
                  v-slot="{ errors, classes }"
                  rules="required"
                  name="First Name"
                >
                  <div
                    class="col-sm-4 col-md-3"
                    :class="classes"
                  >
                    <input
                      v-model="localUserProfile.firstName"
                      type="text"
                      class="form-control"
                      name="firstName"
                    >
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>

              <!-- Last Name -->
              <div class="form-group">
                <label class="col-sm-3 col-md-3 control-label">
                  {{ $t('PROFILE_LAST_NAME') }}
                  <a
                    v-tooltip="$t('PROFILE_LAST_NAME_TT')"
                    class="tooltip-icon"
                  >
                    <i class="fa m-l-3 fa-question-circle" />
                  </a>
                </label>
                <ValidationProvider
                  v-slot="{ errors, classes }"
                  rules="required"
                  name="Last Name"
                >
                  <div
                    class="col-sm-4 col-md-3"
                    :class="classes"
                  >
                    <input
                      v-model="localUserProfile.lastName"
                      type="text"
                      class="form-control"
                      name="lastName"
                    >
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>

              <!-- Mobile Number -->
              <div class="form-group">
                <label class="col-sm-3 col-md-3 control-label">
                  {{ $t('PROFILE_MOBILE_NUMBER') }}
                  <a
                    v-tooltip="$t('PROFILE_MOBILE_NUMBER_TT')"
                    class="tooltip-icon"
                  >
                    <i class="fa m-l-3 fa-question-circle" />
                  </a>
                </label>
                <ValidationProvider
                  v-slot="{ classes }"
                  name="phoneNumber"
                >
                  <div
                    class="col-sm-4 col-md-3"
                    :class="classes"
                  >
                    <input
                      v-model="localUserProfile.phoneNumber"
                      type="text"
                      class="form-control"
                      name="phoneNumber"
                    >
                  </div>
                </ValidationProvider>
              </div>

              <!-- Skype Handle -->
              <div class="form-group">
                <label class="col-sm-3 col-md-3 control-label">
                  {{ $t('PROFILE_SKYPE_HANDLE') }}
                  <a
                    v-tooltip="$t('PROFILE_SKYPE_HANDLE_TT')"
                    class="tooltip-icon"
                  >
                    <i class="fa m-l-3 fa-question-circle" />
                  </a>
                </label>
                <ValidationProvider
                  v-slot="{ classes }"
                  name="skype"
                >
                  <div
                    class="col-sm-4 col-md-3"
                    :class="classes"
                  >
                    <input
                      v-model="localUserProfile.skypeHandle"
                      type="text"
                      class="form-control"
                      name="skype"
                    >
                  </div>
                </ValidationProvider>

                <!-- Submit Button -->
                <div class="form-group">
                  <div class="col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3">
                    <PrimaryButton
                      type="submit"
                      size-class="btn-lg"
                      :show-loader-on-form="isUpdating"
                      :disabled="pristine || invalid"
                    >
                      {{ $t('PROFILE_UPDATE_BUTTON') }}
                    </PrimaryButton>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </ValidationObserver>

      <ChangePassword />
    </div>

    <div
      v-if="isLoading"
      class="text-center empty-records"
    >
      <Loader />
      <span v-t="'PROFILE_LOADING'" />
    </div>
  </PortalWidget>
</template>
<script>
import sharedMessages from '@/core/locales';
import messages from '../locales';
import Loader from '@/core/components/Loader';
import PortalWidget from '@/core/components/PortalWidget.vue';
import PrimaryButton from '@/core/components/PrimaryButton';
import ChangePassword from './ChangePassword.vue';
import { ringbaUserService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import _ from 'lodash';

export default {
  name: 'UserProfile',
  components: {
    Loader,
    PortalWidget,
    PrimaryButton,
    ChangePassword
  },
  data: () => ({
    isLoading: true,
    isUpdating: false,
    triedToSend: false,
    localUserProfile: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      skypeHandle: ''
    },
  }),
  beforeMount() {
    this.widget = {
      title:this.$i18n.t('PROFILE_PAGE_TITLE'),
      iconClass: 'typcn typcn-user'
    };
  },
  created() {
    this.initializeLocalUserProfile();
  },
  methods: {
    async updateProfile() {
      try {
        this.isUpdating = true;
        this.triedToSend = true;
        const response = await ringbaUserService.updateProfile(this.localUserProfile);
        this.localUserProfile = _.cloneDeep(response.data.profile);
        utilities.showToaster('success', this.$t('PROFILE_UPDATE_SUCCESS'));
      } catch (error) {
        utilities.errorHandler(error);
      }
      this.isUpdating = false;
      this.triedToSend = false;
    },

    async _loadProfile() {
      try {
        const response = await ringbaUserService.getProfile();
        this.localUserProfile = _.cloneDeep(response.data.profile);
      } catch(error) {
        utilities.errorHandler(error);
      }
    },

    initializeLocalUserProfile() {
      this._loadProfile();
      this.isLoading = false;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>
